import { DomApplier } from '../cssFeatures.types'
import { getVariantSelectors } from '../../utils/variantsUtils'

function transformToSingleSelector(selectors: Array<string>) {
	return selectors.map((selector_) => `${selector_}`).join(',')
}

function hasNamedEffect(item: any) {
	return item && item.namedEffect ? true : false
}

function getSelectorsAndStyles(variantSelectorsArgs: any, hasEffect: boolean) {
	const { variantKey, variants, compId, cssContext } = variantSelectorsArgs

	return [
		{
			selector: transformToSingleSelector(
				getVariantSelectors(variantKey, variants, `${compId}webglcanvas`, cssContext)
			),
			style: { display: hasEffect ? 'block' : 'none' },
		},
	]
}

export const canvasDomApplier: DomApplier<'canvas'> = (
	{ id: compId },
	idSelector,
	breakpointId,
	{ canvas },
	cssContext
) => {
	if (canvas) {
		return canvas
			.flatMap(({ data: breakpointToEffect, variants }) => {
				const { default: defaultBreakpoint, ...restOfBreakpoints } = breakpointToEffect
				const defaultStyles = Object.entries(defaultBreakpoint).flatMap(([variantKey, item]) =>
					getSelectorsAndStyles({ variantKey, variants, compId, cssContext }, hasNamedEffect(item))
				)

				if (breakpointId === 'default') {
					return defaultStyles
				}

				return restOfBreakpoints[breakpointId]
					? Object.entries(restOfBreakpoints[breakpointId]).flatMap(([variantKey, item]) =>
							getSelectorsAndStyles(
								{
									variantKey,
									variants,
									compId,
									cssContext,
								},
								hasNamedEffect(item)
							)
					  )
					: []
			})
			.reduce<Record<string, {}>>((acc, selectorAndStyle) => {
				const { selector, style } = selectorAndStyle
				acc[selector] = style
				return acc
			}, {})
	}

	return null
}
